<template>
  <custom-dialog width="60%" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="location-device-dialog">
      <div class="ub" style="height: 480px">
        <div class="ub-f1 ubv" style="padding-right: 24px">
          <div class="tit">{{ $t('Common.com_location') }}</div>
          <div style="padding-bottom: 16px">
            <search-input width="100%" :placeholder="$t('Common.com_location_name')" v-model="appKey" @fetch="filterLocation"></search-input>
          </div>
          <ul class="list ub-f1">
            <li :class="[{ cur: locationData.locationId === item.locationId }]" v-for="(item, index) in locationFilter" :key="index" @click="handleNodeClick(item)" class="ub">
              <div class="box">
                <i class="icon icon-xiangmu"></i>
              </div>
              <div class="name line1 ub-f1">{{ item.locationName }}</div>
            </li>
          </ul>
        </div>
        <div style="width: 1px; background: #f5f5f5"></div>
        <div class="ub-f1 ubv" style="padding-left: 24px">
          <div class="tit">{{ $t('Common.com_site') }}</div>
          <div style="padding-bottom: 16px">
            <search-input width="100%" :placeholder="$t('Common.com_site_name')" v-model="appKey1" @fetch="filterSite"></search-input>
          </div>
          <ul class="list ub-f1">
            <li :class="[{ cur: siteData.siteId === item.siteId }]" v-for="(item, index) in siteFilter" :key="index" @click="handleSiteClick(item)" class="ub">
              <div class="box">
                <i class="icon icon-mianji" style="color: #93da49"></i>
              </div>
              <div class="name line1 ub-f1">{{ item.siteName ||'-'}}</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="info">
        <span style="color: #4d4d4d">{{ locationData.locationName }}</span>
        <span v-if="siteData.siteName">&ensp;>&ensp;{{ siteData.siteName ||'-'}}</span>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="warning" :disabled="!siteData.siteId" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      appKey: '',
      appKey1: '',
      locationData: {},
      locationList: [],
      locationFilter: [],
      siteData: {},
      siteList: [],
      siteFilter: [],
    };
  },
  mounted() {
    this.getLocatonList();
    this.getFuncView();
    if (this.model.tableSelect.length && this.model.tableSelect[0].locationId) {
      this.locationData = this.model.tableSelect[0];
      this.handleNodeClick(this.locationData);
      this.siteData = this.model.tableSelect[0];
    }
  },
  methods: {
    // 确认保存
    confirm: function () {
      this.$postJSON(apis.locationDeviceAssociate, {
        deviceIdList: this.model.tableSelect.map(t => t.deviceId),
        toBizId: this.siteData.siteId || this.locationData.locationId,
        toBizType: this.siteData.siteId ? 3 : 1,
      }).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.visible = false;
        this.$emit('success');
      });
    },
    // 获取项目列表
    getLocatonList: function () {
      this.$getJSON(apis.portalLocationList, {
        orgId: this.model.orgId || this.userInfo.rootOrgId,
      }).then((res) => {
        this.locationList = res.data;
        this.filterLocation();
      });
    },
    // 项目列表过滤
    filterLocation: function () {
      if (!this.appKey) {
        this.locationFilter = this.locationList;
        return;
      }
      this.locationFilter = this.locationList.filter(t => t.locationName.includes(this.appKey));
    },
    // 选中项目
    handleNodeClick: function (item) {
      this.locationData = item;
      this.siteData = {};
      this.getSiteList();
    },
    // 获取站点
    getSiteList: function () {
      this.$getJSON(apis.locationSiteList, {
        locationId: this.locationData.locationId,
      }).then((res) => {
        this.siteList = res.data;
        this.filterSite();
      });
    },
    // 站点列表过滤
    filterSite: function () {
      if (!this.appKey1) {
        this.siteFilter = this.siteList;
        return;
      }
      this.siteFilter = this.siteList.filter(t => t.siteName.includes(this.appKey1));
    },
    // 选中站点
    handleSiteClick: function (data) {
      this.siteData = { ...data };
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.location-device-dialog {
  padding: 0 24px;
  .tit {
    color: $--color-text-regular;
    margin-bottom: 16px;
    font-weight: bold;
    line-height: 20px;
    font-size: 14px;
  }
  .info {
    margin-top: 24px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    color: $--color-primary;
    font-weight: bold;
  }
  .list > li {
    height: 40px;
    line-height: 39px;
    cursor: pointer;
    padding-right: 12px;
    border: 1px solid transparent;
    .box {
      width: 38px;
      text-align: center;
      color: $--color-primary;
      .icon {
        font-size: 16px;
      }
    }
    .name {
      color: $--color-text-regular;
      font-size: 14px;
    }
    &.cur {
      border: 1px solid $--color-primary;
      border-radius: 8px;
      box-sizing: border-box;
      background: #f8f9fa;
      .name {
        color: $--color-primary;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
}
</style>
